var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnlockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#unlockIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.778 10.333A1.78 1.78 0 0 0 4 12.111v5.334c0 .98.797 1.777 1.778 1.777h8.889a1.78 1.78 0 0 0 1.777-1.777V12.11a1.78 1.78 0 0 0-1.777-1.778h-8.89Zm5.333 5.334H9.333a.888.888 0 1 1 0-1.778h1.778a.888.888 0 1 1 0 1.778Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 6.778A2.222 2.222 0 0 0 13.778 9v1.333H12V9a4.001 4.001 0 0 1 8 0v1.333a.888.888 0 1 1-1.778 0V9A2.222 2.222 0 0 0 16 6.778Z",
  opacity: 0.8
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "unlockIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 5h16v14.222H4z"
})))));
export default SvgUnlockIcon;